var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"WarehouseSelector"},[_c('el-cascader',{style:({'width' : _vm.width}),attrs:{"value":_vm.selectArray,"placeholder":_vm.isFilter? '全部' : _vm.plcText,"options":_vm.tree,"props":{value:'id', label: 'name'},"change-on-select":_vm.isFilter},on:{"change":_vm.itemChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }